import React from 'react'
import { connect } from 'react-redux'
import BigCalendar from "react-big-calendar";
import { ClipLoader } from 'react-spinners';
import { first, last } from "lodash";
import moment from 'moment'
import styled from 'styled-components'
import classnames from 'classnames'

const WeekEventContainer = styled.div`
  line-height: 1.3;
`

function WeekEvent({ event }){

  return(
    <WeekEventContainer>
      {event.title}
    </WeekEventContainer>
  )
}

function MainCalendarView(props){
  const { organizationName, calendars, updateFilter, current_user } = props
  const isAnyCalendarLoading = calendars.filter(calendar=>calendar.isLoading).length > 0

  // styling for individual events on the calendar
  function handleEventPropGetter(event, start, end, isSelected){
    return {
      style: {
        backgroundColor: event.color,
        color: 'white',
        border: '0px',
      }
    }
  }

  function aggregateEventsFromAllVisibleCalendars(){
    var events = []
    calendars.filter(calendar=>calendar.visible).map(calendar => {
      calendar.events.map(event => {
        events.push({
          id: event.id,
          title: event.title ? event.title : 'Unamed Event',
          start: moment(event.start).toDate(),
          end: moment(event.end).toDate(),
          allDay: event.allDay,
          color: calendar.color,
        })
      })
    })
    return events
  }

  function handleRangeChange(range) {
    const filter = 
      Array.isArray(range)?
      {
        startDate: moment(first(range)).subtract(1, "ms").toISOString(),
        endDate: moment(last(range)).endOf("day").toISOString()
      }
      :
      {
        startDate: moment(range.start).startOf("day").toISOString(),
        endDate: moment(range.end).endOf("day").toISOString()
      }
    updateFilter(filter)
  }
  
  function handleSelectEvent(targetEvent){
    window.open(`/organizations/${organizationName}/events/${targetEvent.id}?starts_at=${moment(targetEvent.start).format()}&ends_at=${moment(targetEvent.end).format()}`)
  }


	return(
		<div className="col-xs-12 col-lg-9 h-100 p-3 d-lg-inline-block bg-white">
      <div className="d-flex justify-content-between align-items-center pb-3">
        <div>{ isAnyCalendarLoading && <RefreshingMessage/> }</div>
        <a className="btn btn-sm btn-primary" href={`/organizations/${organizationName}/agenda/select_user_type`}>Create New Event</a>
      </div>
      <div className="pb-5 w-100" style={{height: 'calc(100% - 48px)'}}>
      {
        isAnyCalendarLoading &&
        <div style={{height: 'calc(100% - 200px)'}} className="d-flex justify-content-center align-items-center">
          <ClipLoader color={'#20a8d8'}/>
        </div>
      }
  			<BigCalendar
          localizer={BigCalendar.momentLocalizer(moment)}
          events={aggregateEventsFromAllVisibleCalendars()}
          onRangeChange={handleRangeChange}
          onSelectEvent={handleSelectEvent}
          eventPropGetter={handleEventPropGetter}
          defaultView="week"
          components={{ week : { event: WeekEvent  } }}
          height={'calc(100% - 200px)'} 
          className={classnames({"d-none" : isAnyCalendarLoading})}
          />
      </div>
		</div>
	)
}

function RefreshingMessage(){
  return(
    <div className="d-flex align-items-center pt-1 pb-1 pl-2 pr-2">
      <ClipLoader
        sizeUnit={"px"}
        size={14}
        color={'#20a8d8'}
        loading={true}/>
      <span className="ml-2 text-primary" style={{fontWeight: 500}}>Refreshing Calendar...</span>
    </div>
  )
}

const mapStateToProps = (state, ownProps) => {
  return {
    organizationName: state.organization.name,
    calendars: state.calendars,
    current_user: state.current_user,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateFilter: (obj) => dispatch({ type: 'UPDATE_FILTER', payload: obj })
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MainCalendarView);
